const initialState = null;

const expressions = (state = initialState, action) => {
    switch (action.type) {
        case 'SET_EXPRESSIONS': {
            return action.payload;
        }

        default: {
            return state;
        }
    }
};

export default expressions;
